import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { isMobile } from 'react-device-detect';
import { IParlamentar } from '../../../models/Parlamentar.Model';
import { usePallet } from '../../../contexts/PalletContext';
import { ParlamentarConsultaInformacoes } from './ParlamentarConsultaInformacoes';
import { ParlamentarConsultaMenuParlamentar } from './ParlamentarConsultaMenuParlamentar';
import ParlamentarCarouselTabsPerfil from './ParlamentarCarouselTabsPerfil';

export const ParlamentarConsultaAbas = (props: {
    parlamentar: IParlamentar | undefined;
    idPermissao: number;
    id_parlamentar: number;
    onChange?: () => void;
    onBlur?: () => void;
}) => {
    const { pallet } = usePallet();
    const [aba, setAba] = useState(0);

    const comMenu = props.idPermissao !== 4;

    return (
        <Box>
            <Box sx={{
                pl: isMobile ? '20px' : '50px',
                pr: isMobile ? '20px' : '50px',
                pt: '20px',
                borderBottom: '1px solid #EAEAEA',
            }}>
                <Tabs
                    value={aba}
                    onChange={(_, v) => setAba(v)}
                    TabIndicatorProps={{ style: { background: pallet.color.primary.background } }}
                    sx={{
                        minHeight: 40,
                        '& .Mui-selected': { color: `${pallet.textColorQuaternary} !important` },
                        '& .MuiButtonBase-root': { padding: '12px 16px' },
                    }}
                >
                    <Tab label="PERFIL" sx={{ fontFamily: pallet.fontFamily.general, fontWeight: 700, fontSize: '16px' }} />
                    <Tab label="INFORMAÇÕES" sx={{ fontFamily: pallet.fontFamily.general, fontWeight: 700, fontSize: '16px' }} />
                    {comMenu && (
                        <Tab label="MENU DO INTERLOCUTOR" sx={{ fontFamily: pallet.fontFamily.general, fontWeight: 700, fontSize: '16px' }} />
                    )}
                </Tabs>
            </Box>

            {aba === 0 && (
                <ParlamentarCarouselTabsPerfil
                    activeTab={0}
                    index={0}
                    id_parlamentar={props.id_parlamentar}
                    parlamentar={props.parlamentar}
                    permissaoUsuario={props.idPermissao}
                />
            )}

            {aba === 1 && (
                <ParlamentarConsultaInformacoes parlamentar={props.parlamentar} />
            )}

            {comMenu && aba === 2 && (
                <ParlamentarConsultaMenuParlamentar
                    parlamentar={props.parlamentar}
                    onChange={props.onChange}
                    onBlur={props.onBlur}
                    idPermissao={props.idPermissao}
                />
            )}
        </Box>
    );
};
